export default {
    "html" : require("./html").default,
    "css": require("./css").default,
    "scss": require("./scss").default
}